import React, { Fragment, useContext  } from 'react'
import {useNavigate } from 'react-router-dom';
import { PatientContext } from '../../Context/PatientContext.js';
import * as Yup from 'yup';
import { useFormik } from 'formik';

export default function OrderOldPatient() {
   const {patient , setPatient , loading } = useContext(PatientContext) ;
   const navigate = useNavigate()

   async function submitOrder(values){
      setPatient(values) ;
      navigate("/Checkout")
   }

   let validationSchema = Yup.object({
      patient_Name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
      patient_Phone:Yup.string().required().trim() ,
      birthDay:Yup.string().required().trim() ,
      gender:Yup.string().required().oneOf(["male" , "female"]) ,
   })

   let formik = useFormik({
      initialValues:{
         patient_Name: patient.patient_Name || "" ,
         patient_Phone: patient.patient_Phone || "",
         birthDay: patient?.birthDay?.slice(0,10) || "",
         gender: "" ,
      }  , validationSchema , 
      onSubmit:submitOrder
   })


   return (
      <Fragment>

         <div  dir='rtl' className="w-75 p-2 m-auto mt-5 OrderLoggedUser">
            <h6>تعديل بيانات المريض المحفوظة :</h6>            
            {loading? <h2>Loading ... <i className="fa-solid fa-spinner fa-spin fa-rotate-180 "></i></h2> : ""}


            <form action="" onSubmit={formik.handleSubmit}>

               <div className="my-1">
                  <label htmlFor="patient_Name" className="form-label">اسم المريض</label>
                  <input type="text" 
                     value={formik.values.patient_Name}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="patient_Name"  
                     name="patient_Name" 
                     placeholder="اسم المريض" />
                  {formik.errors.patient_Name && formik.touched.patient_Name?<div className="alert alert-danger mt-4 p-2">{formik.errors.patient_Name}</div> :""}
               </div>



               <div className="my-1">
                  <label htmlFor="patient_Phone" className="form-label">رقم تليفون المريض</label>
                  {/* <input type="tel"  */}
                  <input type="text" 
                     value={formik.values.patient_Phone}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="patient_Phone"  
                     name="patient_Phone" 
                     placeholder="01X XXX XXX XX" />
                  {formik.errors.patient_Phone && formik.touched.patient_Phone?<div className="alert alert-danger mt-4 p-2">{formik.errors.patient_Phone}</div> :""}
               </div>



               <div className="my-1">
                  <label htmlFor="birthDay" className="form-label">تاريخ ميلاد المريض</label>
                  <input type="text" 
                     value={formik.values.birthDay}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="birthDay"  
                     name="birthDay" 
                     placeholder="YYYY-MM-DD" />
                  {formik.errors.birthDay  && formik.touched.birthDay?<div className="alert alert-danger mt-4 p-2">{formik.errors.birthDay}</div> :""}
               </div>




               <label htmlFor="">
                  <p className='text-end'>الحالة :</p>
                  <div className="form-check form-check-inline">
                     <input className="form-check-input" type="radio" 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        value="male"
                        id="male"
                        name="gender" />
                     <label className="form-check-label" htmlFor="male">ذكر</label>
                  </div>


                  <div className="form-check form-check-inline mx-5">
                     <input className="form-check-input" type="radio" 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        value="female"
                        id="female"
                        name="gender" />
                     <label className="form-check-label" htmlFor="female">أنثى</label>
                  </div>
               </label>


               <div className="d-grid gap-2 col-6 mx-auto">
                  <button  disabled={!(formik.isValid && formik.dirty)}  type="submit" className="btn bg-main text-white btn-sm mt-2">أنتقل للدفع</button>
               </div>
               
            </form>
         </div>

      </Fragment>
   )
}

